import { completeWordBuildRound } from '../miniTasksApi';
import { clearWordBuildLocalProgress, writeWordBuildLocalProgress } from './wordBuildSessionStorage';

export function playLocalWordBuildAttempt(round, boardSessionId, previousAttempts, {
  questionId, answer, idempotencyKey,
}) {
  const words = round.words || [];
  const position = Number(round.completed_word_count || 0);
  const word = words[position];
  if (!word || String(word.question_id) !== String(questionId)) {
    throw new Error('Bu kelime artık aktif değil.');
  }

  const normalizedAnswer = String(answer).normalize('NFC').trim();
  const correct = normalizedAnswer === String(word.correct_answer).normalize('NFC');
  const lastAttempt = previousAttempts[previousAttempts.length - 1];
  const isFinalAnswer = correct && position + 1 === words.length;
  const repeatFinal = isFinalAnswer
    && lastAttempt?.question_id === Number(questionId)
    && lastAttempt?.answer === normalizedAnswer;
  const attempts = repeatFinal || lastAttempt?.idempotency_key === idempotencyKey
    ? previousAttempts
    : [...previousAttempts, {
      question_id: Number(questionId), answer: normalizedAnswer, idempotency_key: idempotencyKey,
    }];
  const attemptCount = Number(round.current_word?.attempt_count || 0) + 1;
  const attempt_result = {
    correct,
    attempt_count: attemptCount,
    completed_word_count: position + (correct ? 1 : 0),
  };

  if (isFinalAnswer) {
    writeWordBuildLocalProgress(round, attempts);
    const result = completeWordBuildRound(round.round_id, boardSessionId,
      attempts.map(({ question_id, answer: attemptAnswer }) => ({ question_id, answer: attemptAnswer })))
      .then(({ summary }) => {
        clearWordBuildLocalProgress(round.round_id);
        return { round_completed: true, attempt_result, summary };
      });
    return { attempts, result };
  }

  const nextRound = correct
    ? { ...round, completed_word_count: position + 1, current_word: words[position + 1] }
    : { ...round, current_word: {
      ...round.current_word,
      attempt_count: attemptCount,
      tiles: [...(round.current_word.tiles || []).slice(1), round.current_word.tiles[0]],
    } };
  writeWordBuildLocalProgress(nextRound, attempts);
  return {
    attempts,
    result: Promise.resolve({ round_completed: false, attempt_result, round: nextRound }),
  };
}
